export default "__VITE_ASSET__ab0838cf__"